import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="font-heading text-xl" data-testid="forgot-title">Mot de passe oublié</CardTitle>
          <CardDescription>Reçois un lien de réinitialisation par email (valable 1 heure).</CardDescription>
        </CardHeader>
        <CardContent>
          {message ? (
            <div className="bg-teal-50 border border-teal-200 text-teal-800 text-sm rounded-lg px-4 py-3" data-testid="forgot-success-message">
              {message}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-orange-50 border border-orange-200 text-orange-800 text-sm rounded-lg px-4 py-3" data-testid="forgot-error">
                  {error}
                </div>
              )}
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
              </div>
              <Button type="submit" className="w-full bg-teal-600 hover:bg-teal-700" disabled={loading} data-testid="forgot-submit-button">
                {loading ? "Envoi..." : "Envoyer le lien"}
              </Button>
            </form>
          )}
          <Link to="/connexion" className="mt-4 block text-center text-sm text-teal-700 hover:underline" data-testid="back-to-login-link">
            Retour à la connexion
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
